import { Icons } from "../../../../../icons/icons";

export default function FooterMiddleCard({ footerCopy }) {
  return (
    <div className="site-footer__col site-footer__middle-card">
      <h4>{footerCopy.middleTitle}</h4>
      <div className="site-footer__title-line" />

      <p className="site-footer__description">{footerCopy.description}</p>

      <div className="site-footer__highlights">
        {footerCopy.highlights.map((item) => {
          const HighlightIcon = item.Icon || Icons.Leaf;

          return (
            <div className="site-footer__highlight-item" key={item.title}>
              <span className="site-footer__highlight-icon">
                <HighlightIcon />
              </span>

              <div>
                <strong>{item.title}</strong>
                <small>{item.text}</small>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}